import * as React from "react";
import { useLocation } from "react-router-dom";

import { setNavPending, useNavPending } from "@/lib/navigation-progress";

// Abaixo disso o chunk normalmente já está em cache e a navegação é
// instantânea — mostrar a barra só produziria um flash.
const SHOW_DELAY_MS = 150;

// Rede muito ruim, chunk que falhou ou navegação abortada: evita deixar a
// barra presa na tela para sempre.
const MAX_WAIT_MS = 15000;

/**
 * Barra de progresso no topo da tela enquanto o chunk da rota destino é
 * baixado. Renderizada uma única vez, na raiz do router (`main.tsx`), fora do
 * `<Suspense>` — assim continua visível enquanto a transition está suspensa.
 */
export function NavigationProgress() {
  const pending = useNavPending();
  const { pathname, search } = useLocation();
  const [visible, setVisible] = React.useState(false);

  // Como a troca de rota acontece dentro de uma transition, o location só muda
  // quando ela commita — ou seja, quando a nova página entrou de fato na tela.
  React.useEffect(() => {
    setNavPending(false);
  }, [pathname, search]);

  React.useEffect(() => {
    if (!pending) {
      setVisible(false);
      return;
    }

    const show = setTimeout(() => setVisible(true), SHOW_DELAY_MS);
    const bail = setTimeout(() => setNavPending(false), MAX_WAIT_MS);

    return () => {
      clearTimeout(show);
      clearTimeout(bail);
    };
  }, [pending]);

  if (!visible) return null;

  return (
    <div
      role="progressbar"
      aria-label="Carregando página"
      className="fixed inset-x-0 top-0 z-100 h-0.5 overflow-hidden bg-primary/15"
    >
      <div className="ec-nav-progress h-full w-1/3 rounded-full bg-primary" />
    </div>
  );
}
